<div *ngIf="wrapped" class="form-group" [ngClass]="wrappedClass">
  <label for="{{name}}">{{label || (name | stringSpacer)}}:</label>
  <div class="input-group">
    <input #calendarInput [name]="name" [id]="name" [ngClass]="class" class="form-control form-control-sm" [(ngModel)]="dateString" placeholder="{{placeholder}}"
           type="text" [attr.disabled]="disabled ? 'disabled' : null"/>
    <div #calendarButton class="input-group-append" (click)="calendarButtonClicked()">
      <div class="input-group-text"><i class="fa fa-calendar"></i></div>
    </div>
  </div>
</div>

<div *ngIf="!wrapped" class="input-group">
  <div class="input-group date" id="datepicker">
    <input #calendarInput [name]="name" [id]="name" [ngClass]="class" class="form-control form-control-sm" [(ngModel)]="dateString" placeholder="{{placeholder}}"
           type="text" [attr.disabled]="disabled ? 'disabled' : null"/>
    <div #calendarButton class="input-group-append" (click)="calendarButtonClicked()">
      <div class="input-group-text"><i class="fa fa-calendar"></i></div>
    </div>
  </div>
</div>
